import { LastWebsocketJsonMessageType } from '@interfaces/webSocketConnectionInfo';

const useHandleWebsocketMsg = (
  lastJsonMessage: LastWebsocketJsonMessageType,
) => {
  //for myta specific
};

export default useHandleWebsocketMsg;
